<template>
  <div>
    <div style="width: 100%; height: 408px; margin-bottom: 80px;">
      <!-- <div class="daohang zzjz">

        <div class="swiper">
          <div class="block">
            <el-carousel height="372px" style="margin-block-start: unset">
              <el-carousel-item v-for="(item, index) in bannerList" :key="index" @click.native="topage(item.h5Url)">
                <h3 class="small">
                  <img :src="item.bannerImg" width="100%" height="100%" alt />
                </h3>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

      </div> -->
      <img src="~assets/tmpBanner.svg" alt="" class="tmpBanner" @click="jumpToDownload()">
    </div>
    
    <div class="frame">
      <t-code :t-name="timg1" class="peopleapp"></t-code>

    </div>
    <com-views :msg='msg' :type="'video'"></com-views>
  </div>
</template>

<script>
import comViews from 'components/common/comviews/comViews'
import TCode from 'components/common/tcode/TCode'
import { getBanner } from 'network/getData'

export default {
  components: {
    comViews,
    TCode,
  },
  // metaInfo () {
  //   return {
  //     meta: [
  //       { name: 'keywords', content: '科普视频,专家文章,专家音频,名医问答,查疾病,瑞尔安心、瑞尔良医、瑞尔良医app、瑞尔安心官网、瑞尔视景、瑞尔视景科技有限公司、单道动态心电记录仪、7天可穿戴心电监测设备、智能心电监测设备' },
  //       { name: 'description', content: '瑞尔安心在线平台,专家,疾病,科室等详细信息,由专家生产的科普视频,文章,音频等内容,瑞尔安心平台向全民提供“科普视频+语音问答+图文咨询+文章+大数据分析”多位一体的精准健康科普知识，满足大众多样化、多场景应用的健康科普需求。致力于通过互联网技术推动医生共享、知识共享、服务共享、经济共享，放大医生价值和健康科普内容价值，用通俗易懂的方式以及直白语言，制作出大众听得懂、记得住、学得会、用得上的健康科普知识，切实提升公众健康素养，让更多人能够健康地享受美好生活，助力全民健康。研发出多款医疗器械，实现了心脑血管病患者、高危人群得日常疾病筛查和健康管理，并配套了全程专业的健康管理服务，在国内医疗产品行业中具有很高的地位和影响。公司主要从事公司下设医学研发中心、软件开发中心、生产制造中心、营销中心、医学服务中心。' }
  //     ]
  //   }
  // },
  data() {
    return {
      msg: {
        title: require('../../assets/popuvideo.svg'),
        tjtitle: '视频推荐',
        color: '#4263EB',
        etitle: 'Featured VIDEOS'
      },
      bannerList: [],
      timg1: {
        tname: '道特林克就诊小助手',
        img: require('../../assets/kh.svg')
      },
    }
  },
  methods: {
    async getBannerList(type) {
      try {
        const result = await getBanner(type)
        if (type === 'index') {
          this.bannerList = result.data.data
        } else if (type === 'rsider') {
          this.rsiderList = result.data.data
        } else if (type === 'lsider') {
          this.lsiderList = result.data.data
        }
        console.log('this.bannerList', this.bannerList)
      } catch (error) {
        // console.log(error)
      }
    },
    topage(e) {
      const asd = e.split('|')
      if (asd[1] === 'video') {
        // sessionStorage.setItem('nav', '2')
        sessionStorage.setItem('id', asd[0])
        this.$router.push({ path: '/mobVideoCenterDel', query: { videoId: asd[0] } })
      } else if (asd[1] === 'audio') {
        // sessionStorage.setItem('nav', '3')
        sessionStorage.setItem('id', asd[0])
        this.$router.push({ path: '/mobVideoCenterAudioDel', query: { audioId: asd[0] } })
      } else if (asd[1] === 'article') {
        // sessionStorage.setItem('nav', '4')
        sessionStorage.setItem('id', asd[0])
        this.$router.push({ path: '/mobVideoCenterArticleDel', query: { articleId: asd[0] } })
      } else if (asd[1] === 'qa') {
        // sessionStorage.setItem('nav', '5')
        this.$router.push({ path: '/mobQuestionCenterDel', query: { qaId: asd[0] } })
      } else if (e === 'empty') {
        return ''
      } else {
        window.open(e)
      }
    },
    jumpToDownload(){
      this.$router.push('/downapp')
    }
  },
  mounted() {
    this.getBannerList('index')
  }
}
</script>

<style scoped>
.daohang {
  position: absolute;
  width: 100%;
  height: 408px;
  /* left: 120px; */
  top: 100px;
}

.swiper {
  position: absolute;
  width: 100%;
  /* height: 382px; */
  /* background: #D9D9D9; */
  /* left: 242px; */
  /* top: 26px; */
}

.frame {
  position: fixed;
  height: 230px;
  left: 93.36%;
  right: 0.69%;
  top: 335px;
  z-index: 999;
}

.peopleapp {
  position: absolute;
  height: 110px;
  left: 0%;
  right: 0%;
  top: 0px;
}
.tmpBanner{
  position: absolute;
  width: 100%;
  height: 406px;
  left: 0;
  right: 0;

}
</style>
